export default "__VITE_ASSET__8ca48ec7__"